import axios from 'axios';
import moment from 'moment';
import { objectToFormData } from 'object-to-formdata';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { RenderFileUpload, RenderTextEditor } from '../../component/formInput';
import TicketStatus from '../../component/TicketStatus';
import { StringUtils } from '../../utils/javascriptUtils';
import BlockUI from '../../component/BlockUI';
import FileRender from '../../component/FileRender';
import { ToastContainer, toast } from 'react-toastify';
import { SocketUtils, NumberUtils } from '../../utils/javascriptUtils';
import ChangeTicketModal from './modal/ChangeTicketModal';
import TicketRateModal from './modal/TicketRateModal';
import { TicketPageRole } from '../../component/UserPermission';

var _ = require('lodash');

function VPSButtonGroup(user_product, vmData, isLoadingVm, onStartVM, onPowerOffVM, onRestartVM, startActionLoading, powerOffActionLoading, restartActionLoading ) {
  const btn_style = { margin: 5, alignItems: "center", padding: "8px 0px", fontSize: "10px", width: "80px" };
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12 card-group-control card-group-control-right">
          <div className="card">
            <div className="card-header bg-light">
              <h6 className="card-title">
                <a data-toggle="collapse" className="text-body collapsed" href="#collapsible-control-right-group1" aria-expanded="false">
                  <i className="icon-wrench2"></i>
                  <strong>Quản Lý Dịch Vụ: </strong> {user_product.product.product_type}
                </a>
              </h6>
            </div>
            <div id="collapsible-control-right-group1"  className="card-body collapse">
              {isLoadingVm && <center><img width={30} src="/assets/img/squares.gif" alt="verify"/></center>}
              {!vmData && !isLoadingVm && <center>Không Tìm Thấy VM</center>}
              {vmData && <div>
                <center>
                <center>
                  <span> IP Address: </span> 
                  <strong>{user_product.ip_address}</strong>
                </center>
                  <span> VM Status: </span> 
                  {vmData.status === 0 && <span className="text-danger">VPS is off</span> }
                  {vmData.status === 1 && <span className="text-green">VPS is on</span> }
                  {vmData.status === 2 && <span className="text-grey">VPS is suspended</span> }
                </center>
                <center>
                  <span> Khách hàng: </span> 
                  <strong>{vmData.email}</strong>
                </center>
                <div style={{justifyContent: "center"}} className="card-body row">
                  <button className="card product-item" disabled={startActionLoading || vmData.status === 1} onClick={() => onStartVM(user_product.id, "start")} style={btn_style}>
                    <i className="icon-play4"></i> 
                    Start
                  </button>
                  <button className="card product-item" disabled={powerOffActionLoading || vmData.status === 0} onClick={() => onPowerOffVM(user_product.id, "shutdown")} style={btn_style}>
                    <i className="icon-switch"></i> 
                    Shutdown
                  </button>
                  <button className="card product-item" disabled={restartActionLoading} onClick={() => onRestartVM(user_product.id, "reboot")} style={btn_style}>
                    <i className="icon-sync"></i> 
                    Restart
                  </button>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

// Cấu hình Hosting
function HostingManageGroup(user_product, handleHostingConfig) {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12 card-group-control card-group-control-right">
          <div className="card">
            <div className="card-header bg-light">
              <h6 className="card-title">
                <a data-toggle="collapse" className="text-body collapsed" href="#collapsible-control-right-group1" aria-expanded="false">
                  <i className="icon-wrench2"></i>
                  <strong>Quản Lý Dịch Vụ: </strong> {user_product.product.product_type}
                </a>
              </h6>
            </div>
            <div id="collapsible-control-right-group1"  className="card-body collapse">
            <center>
                <button style={{margin: 5, alignItems: "center", width:"100px"}} className="card btn product-item" key={"HostingConfig_" + user_product.id} onClick={() => handleHostingConfig(user_product)}>
                  <i className="icon-gear"></i> Cấu Hình
                </button>
            </center>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

// Cấu hình DNS cho Domain
function DomainManageGroup(role_path, user_product, dnsDirectUrl) {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12 card-group-control card-group-control-right">
          <div className="card">
            <div className="card-header bg-light">
              <h6 className="card-title">
                <a data-toggle="collapse" className="text-body collapsed" href="#collapsible-control-right-group1" aria-expanded="false">
                  <i className="icon-wrench2"></i>
                  <strong>Quản Lý Dịch Vụ: </strong> {user_product.product.product_type}
                </a>
              </h6>
            </div>
            <div id="collapsible-control-right-group1"  className="card-body collapse">
              <center>
                <div style={{justifyContent: "center"}} className="card-body row">
                  <Link style={{margin: 5, alignItems: "center", width:"120px"}} className="card btn product-item" to={role_path + "/customer/profile/detail/" + user_product.domain_profile_id}>
                    <i className="icon-profile"></i> Bản khai
                  </Link>
                  <a style={{margin: 5, alignItems: "center", width:"120px"}} className="card btn product-item" onClick={() => dnsDirectUrl(user_product.domain)}>
                    <i className="icon-circle-right2"></i> Cấu hình DNS
                  </a>
                </div>
              </center>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

function ActionButtonGroup(onChangeTicketStatus, onReceiveTicket, onShowChangeTicketModal) {
  return (
    <div className="row modal-footer">
      <button type="submit" className="btn btn-primary btn-xlg">Trả lời</button>
      <div className="btn-group" style={{ textAlign: "center" }}>
        <button className="btn btn-danger bg-orange dropdown-toggle btn-xlg" data-toggle="dropdown"  aria-expanded="false">
          Chuyển trạng thái
        </button>
        <div className="dropdown-menu" x-placement="bottom-start">
          <a href="#" onClick={()=>onChangeTicketStatus("DREPLIED")} className="dropdown-item">Đã trả lời</a>
          <a href="#" onClick={()=>onChangeTicketStatus("BPROCESS")} className="dropdown-item">Đang xử lý</a>
        </div>
      </div>
        <button onClick={()=> onShowChangeTicketModal()} type="button" className="btn btn-info btn-xlg">Tách Ticket</button>
        <button onClick={()=> onReceiveTicket()} type="button" className="btn btn-success btn-xlg">Tiếp nhận</button>
        <a href="#" onClick={()=>onChangeTicketStatus("FCLOSED")} type="button" className="btn border-slate text-slate-800 btn-flat">Đóng ticket</a>
    </div>
  )
}

// Thông tin dịch vụ theo loại sản phẩm
function ServiceInfo(user_product) {
  let service_info_html = user_product.product.name;
  if(["VPS", "CLOUD_SERVER_PRO"].includes(user_product.product.product_type)) {
    service_info_html = (
      <React.Fragment>
        <strong>IP Address: {user_product.ip_address}</strong>
        <br/>
        <strong>Code: {user_product.domain}</strong>
        <br/>
        <strong>Server IP: {user_product.server_ip_address}</strong>
        <br/>
        <strong className="text-muted">{user_product.product.name}</strong>
      </React.Fragment>
    )
  }
  if(["SSL","LINUX_HOSTING", "WINDOW_HOSTING", "EMAIL", "VN_DOMAIN", "COM_DOMAIN"].includes(user_product.product.product_type)) {
    service_info_html = (
      <React.Fragment>
        <strong>{user_product.product.name}</strong>
        <br/>
        <strong className="text-muted">{user_product.domain}</strong>
      </React.Fragment>
    )
  }
  return service_info_html;

}

function TicketTable(data, onShowTicketRateModal, user_role) {
  return (
    <div style={{paddingBottom: "0px"}} className="table-responsive">
    <table className="table table-togglable table-hover">
      <thead>
      <tr>
        <th data-toggle="true">Mã</th>
        <th data-hide="phone">Khách hàng</th>
        <th data-hide="phone">Phòng ban</th>
        <th data-hide="phone">Trạng thái</th>
        <th data-hide="phone,tablet">Ngày</th>
        <th data-hide="phone,tablet">Dịch vụ</th>
        {TicketPageRole.isTicketRating(user_role) && <React.Fragment>
          <th data-hide="phone,tablet">Nhân viên</th>
          <th data-hide="phone,tablet">Điểm</th>
        </React.Fragment>}
      </tr>
      </thead>
      <tbody>
        <tr>
          <td>{data.code}</td>
          <td>
            {data.user.email}
            <br/>
            <small>{data.user.agency ? "Đại lý: " + data.user.agency.agency_admin.email : "Khách lẻ" }</small> 
          </td>
          <td>{data.department.name}</td>
          <td><span className="label label-success">{TicketStatus(data.status)}</span></td>
          <td>{data.updated_date}</td>
          <td>
           {!data.user_product && "Khác" }
           {data.user_product && ServiceInfo(data.user_product)}
          </td>
          {TicketPageRole.isTicketRating(user_role) && 
            <React.Fragment>
            <td>
              {data.employee && <span>
                {data.employee.full_name}
                <br/>
                <small className="text-muted">{data.employee.email}</small>
              </span>}
            </td>
            <td>
              <button onClick={() => onShowTicketRateModal(data)} className="btn bg-success btn-sm"> 
                <i className="icon-star-full2 icon-sm"></i> {data.ticket_score}
              </button>
            </td>
          </React.Fragment>}
        </tr>
      </tbody>
    </table>
  </div>)
}

function TicketCommentRows(ticket_comments, customer_id) {
  const inner_ticket_rows = _.map(ticket_comments, function(i, key) {
    let inner_border_top_color = "#00bcd4"; //Info

    if(customer_id == i.user.id){
      inner_border_top_color = "#ff5722"; // Warning
    }
    return (
      <div key={key} className="row">
        <div className="col-md-12">
          <div style={{borderTop:"2px solid " +inner_border_top_color }} className={"card"}>
            <div className="card-body">
              <div className="panel-heading">
                <h6 className="panel-title text-info">
                 {customer_id == i.user.id && <span style={{textTransform: "uppercase"}} className="badge badge-primary">{i.ticket_from}</span>} {i.user.full_name} - [ {i.created_Date} ]
                </h6>
                {ReactHtmlParser(i.content)}
              </div>
            </div>
            {!StringUtils.isEmptyOrSpaces(i.note) && <div className="card-footer">
              <span>{i.note}</span>
            </div>}
            {!StringUtils.isEmptyOrSpaces(i.file_url) && <div className="card-footer">
              <i className="icon-download7"></i> 
              <FileRender directory="ticket-upload" file_name={i.file_url} isDisplay={false} />
            </div>}
            {i.total_like > 0 && <div className="card-footer">
              <span className="badge bg-success badge-pill"> 
              <i className="icon-thumbs-up2"> </i> {i.total_like}  
              </span>
            </div>}
          </div>
        </div>
      </div>
    )
  })

  return inner_ticket_rows;
}

class TicketDetail extends React.Component {
  intervalStatus;
  intervalHAVMStatusLog;
  intervalVmUpidStatus;
  constructor(props) {
    super(props);
    this.state = {
      ticket: null,
      isLoading: true,
      is_show_change_ticket_modal: false,
      is_show_ticket_rate_modal: false,
      has_task_running: false,
      vm_data: null,
      action_type: null,
      is_loading_vm: null,
      backup_list: [],
      startActionLoading: false, 
      powerOffActionLoading: false, 
      restartActionLoading: false
    }
    this.submit = this.submit.bind(this);
    this.reload = this.reload.bind(this);
    this.channel = SocketUtils.socketStore();
    this.channel.join();
  }

  sendSocketChannel = (ticket_id) => {
    const self = this;
    const { ticketModifyReload } = this.props;
    self.channel.push("tadu_customer_ticket_modify", {ticket_id: parseInt(ticket_id), body: "Success To Post Ticket Comment"})
    ticketModifyReload();
  }

  reload() {
    const { ticket_id } = this.props.match.params;
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/ticket/detail/'+ticket_id,
      withCredentials: true
    }).then(function (response) {
      self.setState({
        isLoading: false,
      })
      if(!response.data.isError) {
        const ticketObj = response.data.data;
        const user_product = ticketObj.user_product;
        self.setState({
          ticket: ticketObj,
        })
        user_product && user_product.status !== "FCLOSED" && ["VPS", "CLOUD_SERVER_PRO"].includes(user_product.product.product_type) && self.onVPSManage(user_product);
      }
    });
  }

  onVPSManage(user_product) {
    this.setState({
      is_loading_vm: true
    })
    // Dịch vụ phải ở trạng thái "Đang Hoạt Động".
    this.loadVMStatus(user_product.id);
  }

  submit(values) {
    const { ticket_id } = this.props.match.params;
    const { reset } = this.props;
    const self = this;
    const data_value = {
      ticket_id: ticket_id,
      content: values.content,
      created_Date: moment().format("YYYY-MM-DD HH:mm:ss"),
      ticket_from: "id.tadu.cloud",
      admin_read: true, // TODO admin read,
      note: " ",
      is_tranfer: false,
      file_upload: values.file_upload && values.file_upload[0],
    }
    // convert Object to FormData
    const formData = objectToFormData(data_value);
    this.setState({
        isLoading: true
    })
    return axios({
      method: 'post',
      url: window.api_url + "/admin/api/ticket_comment/reply",
      data: formData,
      withCredentials: true
    }).then(function (response) {
      self.setState({
          isLoading: false
      })
      if(!response.data.isError){
        self.reload();
        self.sendSocketChannel(ticket_id); 
        reset();
      }else {
        throw new SubmissionError(response.data.error)
      }
    });
  }

  onChangeTicketStatus = (status) => {
    const { ticket_id } = this.props.match.params;
    const { reset } = this.props;
    const self = this;
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/ticket/status/update',
      data: {
        ticket_id: ticket_id,
        status: status
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError){
        toast.success("Chuyển đổi trạng thái thành công !.");
        self.sendSocketChannel(ticket_id);
        self.reload();
        reset();
      }
    });
  }

  // Tiếp nhận ticket
  onReceiveTicket = () => {
    const { ticket_id } = this.props.match.params;
    const { reset } = this.props;
    const self = this;
    return axios({
      method: 'post',
      url: window.api_url + "/admin/api/receive/ticket",
      data: {
        ticket_id: ticket_id
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError){
        self.reload();
        self.sendSocketChannel(ticket_id);
        toast.success("Tiếp nhận ticket thành công !");
        reset();
      }
    });
  }

  socketLiveReload() {
    const self = this;
    this.channel.on("crm_ticket_modify", payload => {
      self.reload();
    })
  }

  componentDidMount() {
    this.reload();
    this.socketLiveReload();
    
  }
  
  componentDidUpdate(prevProps, prevState) {
    const ticket_id = prevProps.routeProps.match.params.ticket_id;
    const new_ticket_id = this.props.routeProps.match.params.ticket_id;
    if(ticket_id != null && ticket_id != new_ticket_id) {
      this.reload();
    }
  }

  // Tách ticket sang một ticket khác để dễ hỗ trợ.
  onShowChangeTicketModal = () => {
    this.setState({
      is_show_change_ticket_modal: true
    })
  }

  onShowTicketRateModal = () => {
    this.setState({
      is_show_ticket_rate_modal: true
    })
  }
  
  onHideModal = () => {
    this.setState({
      is_show_change_ticket_modal: false,
      is_show_ticket_rate_modal: false
    })
    this.reload();
  }

  componentWillUnmount() {
    /*
      stop Load status from continuing to run even
      after unmounting this component. Notice we are calling
      'clearTimeout()` here rather than `clearInterval()` 
    */
    clearTimeout(this.intervalStatus);
  }

  // Trạng thái của VM.
  loadVMStatus = async (user_product_id) => {
    const self = this;

    return await axios({
      method: 'get',
      url: window.api_url+ `/api/user/vm/status/${user_product_id}`,
      withCredentials: true
    }).then(function (resp) {
      self.setState({
        is_loading_vm: false
      })
      if(resp.data && !resp.data.isError) {
        self.setState({
          vm_data: resp.data.data,
        })
        self.intervalStatus = setTimeout(self.loadVMStatus.bind(this, user_product_id), 15000);
      }else {
        self.setState({
          ...self.state,
          isLoading: false
        })
      }
      // Trường hợp VM đã bị PAUSED (SUSPEND) từ kythuat.
      if(resp.data.data && resp.data.data.status === 2) {
        clearTimeout(self.intervalStatus);
        clearTimeout(self.intervalRRDStatic);
      }
    })
  }

  startVM = async (user_product_id) => { 
    this.setState({
      startActionLoading: true 
    })
    const self = this;
    
    return await axios({
      method: 'post',
      url: window.api_url + `/api/user/vm/start`,
      withCredentials: true,
      data: {
        user_product_id: user_product_id
      }
    }).then(function (resp) {
      if(resp.data && !resp.data.isError) {
        self.setState({
          startActionLoading: false 
        })
        self.loadVMStatus(user_product_id);              
      }else {
        self.setState({
          startActionLoading: false 
        })
        self.loadVMStatus(user_product_id);              
      }
    })
  }

  powerOffVM = async (user_product_id) => { 
    
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc sẽ Shutdown VPS ?");
    
    if(alert_confirm) {
      this.setState({
        powerOffActionLoading: true 
      })
      return await axios({
        method: 'post',
        url: window.api_url + `/api/user/vm/power_off`,
        withCredentials: true,
        data: {
          user_product_id: user_product_id
        }
      }).then(function (resp) {
        if(resp.data && !resp.data.isError) {
          self.setState({
            powerOffActionLoading: false 
          })
          self.loadVMStatus(user_product_id);              
        }else {
          self.setState({
            powerOffActionLoading: false 
          })
          self.loadVMStatus(user_product_id);              
        }
      })
    }
  }
  
  restartVM = async (user_product_id) => { 
    this.setState({
      restartActionLoading: true 
    })
    const self = this;
    
    return await axios({
      method: 'post',
      url: window.api_url + `/api/user/vm/restart`,
      withCredentials: true,
      data: {
        user_product_id: user_product_id
      }
    }).then(function (resp) {
      if(resp.data && !resp.data.isError) {
        self.setState({
          restartActionLoading: false 
        })
        self.loadVMStatus(user_product_id);              
      }else {
        self.setState({
          restartActionLoading: false 
        })
        self.loadVMStatus(user_product_id);              
      }
    })
  }

  // Handle redirect sang màn hình cấu hình Hosting.
  handleHostingConfig = (user_product) => {
    let url = '/api/user/service/cpanel/manage'
    // Nếu Hệ điều hành của Hosting là window.
    // Nơi cấu hình sẽ là plesk
    if (user_product.product.product_type == "WINDOW_HOSTING") {
      url = '/api/user/service/plesk/manage'
    }
    axios({
      method: 'post',
      url: window.api_url + url,
      withCredentials: true,
      data: {
        user_product_id: user_product.id
      }
    }).then(function (response) {
      if(!response.data.isError && response.data.data != null) {
        window.open(response.data.data,"_blank");
      }else {
        toast.error("Không thể chuyển đến trang cấu hình Hosting ! Vui lòng kiểm tra lại dịch vụ !")
      }
    });
  }

  // Chuyển hướng đến trang quản trị DNS của tên miền.
  dnsDirectUrl = (domain) => {
    axios({
      method: 'post',
      url: window.api_url + '/api/user/service/dns/manage/' + domain,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        const sdns_login_url = "https://sdns.vn/rest/domain/" + domain + "/login/" + response.data.data;
        window.open(sdns_login_url, '_blank', 'noopener');
      }
    });
  }
  
  render() {
    const {handleSubmit, submitting, userProfile, role_path} = this.props;
    const { ticket, isLoading, is_show_change_ticket_modal, is_show_ticket_rate_modal } = this.state;
    const { vm_data, is_loading_vm, startActionLoading, powerOffActionLoading, restartActionLoading } = this.state;
    return(
      <React.Fragment>
        <ToastContainer />
        {isLoading && <BlockUI/>}
        {/* Content area */}
        {!isLoading && !ticket && <div>
          <div className="card card-body">
            <span> Không tìm thấy dịch vụ hỗ trợ !</span>
          </div>
        </div>}
        {ticket && userProfile && <React.Fragment>
          {/* Page header */}
          <div className="page-header">
            <h4>
              <i className=" icon-paragraph-justify2 position-left"></i>
              <span className="text-semibold"> Mã Hỗ Trợ <a>#{ticket.code}</a></span>
            </h4>
          </div>
          {/* Page header */}
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  {TicketTable(ticket, this.onShowTicketRateModal, userProfile.role)}
                </div>
              </div>
            </div>
          </div>
          {ticket.user_product && ticket.status != "FCLOSED" && <React.Fragment>
            {["COM_DOMAIN", "VN_DOMAIN"].includes(ticket.user_product.product.product_type) && DomainManageGroup(
              role_path,
              ticket.user_product,
              this.dnsDirectUrl
            )}
            {["LINUX_HOSTING", "WINDOW_HOSTING"].includes(ticket.user_product.product.product_type) && HostingManageGroup(
              ticket.user_product, 
              this.handleHostingConfig
            )}
            {["VPS", "CLOUD_SERVER_PRO"].includes(ticket.user_product.product.product_type) && VPSButtonGroup(
              ticket.user_product, 
              vm_data,
              is_loading_vm,
              this.startVM,
              this.powerOffVM,
              this.restartVM,
              startActionLoading,
              powerOffActionLoading,
              restartActionLoading
            )}
          </React.Fragment>}
          <div className="row">
            <div className="col-md-12">
              <div className="card" style={{borderTop:"2px solid #ff5722"}}>
                <div className="card-body">
                  <div className="panel-heading">
                    <h6 className="panel-title text-warning">
                    <span style={{textTransform: "uppercase"}} className="badge badge-primary">{ticket.ticket_from}</span> {ticket.title} - [ {ticket.created_date} ]
                    </h6>
                  </div>
                  <div className="panel-body">
                    {ReactHtmlParser(ticket.content)} 
                    <br/>
                  </div>
                </div>
                {!StringUtils.isEmptyOrSpaces(ticket.note) && <div className="card-footer">
                  <span style={{whiteSpace: 'pre-wrap'}}><strong>Ghi chú: <br/></strong>{ticket.note}</span>
                </div>}
                {!StringUtils.isEmptyOrSpaces(ticket.file_url) && <div className="card-footer">
                  <i className="icon-download7"></i> 
                  <FileRender directory="ticket-upload" file_name={ticket.file_url} isDisplay={false} />
                </div>}
              </div>
            </div>
          </div>
          {TicketCommentRows(ticket.ticket_comments, ticket.user_id)}
          <div className="card panel-white">
            <div>
              <form onSubmit={handleSubmit(this.submit)}>
                <br/>
                <div style={{margin:20}} className="form-group">
                  <Field
                    name="content"
                    placeholder="Tiêu để cần hỗ trợ"
                    defaultValue=""
                    component={RenderTextEditor}
                  />
                  <Field
                    name="file_upload"
                    label="File đính kèm"
                    fileAccept="image/*,.zip"
                    component={RenderFileUpload}
                  />
                </div>
                  {ActionButtonGroup(this.onChangeTicketStatus, this.onReceiveTicket, this.onShowChangeTicketModal)}
              </form>
            </div>
          </div>
        {is_show_change_ticket_modal && <ChangeTicketModal ticketId={ticket.id} title={"Tách Ticket"} onHide={this.onHideModal} show={is_show_change_ticket_modal}/>}
        {is_show_ticket_rate_modal && <TicketRateModal ticketObj={ticket} title={"Đánh Giá"} onHide={this.onHideModal} show={is_show_ticket_rate_modal}/>}
        </React.Fragment>}
        {/*content area */}
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path

});

const mapDispatch = (dispatch) => ({
  updateField: (fieldName, value) =>
  dispatch({
    meta: { form: "ticketDetail", field: fieldName },
    payload: value,
    type: "@@redux-form/CHANGE"
  }),
  ticketModifyReload: () => dispatch.messageModify.ticketModifyReload()
});

const TicketDetailWrapper = reduxForm({
  form: 'ticketDetail',
  destroyOnUnmount: true,
  enableReinitialize: true,
  // validate
})(withRouter(TicketDetail));

export default connect(mapState, mapDispatch)(withRouter(TicketDetailWrapper));
